import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, Router } from '@reach/router';
import { useMutation } from '@apollo/client';

import SEO from '../seo';
import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

import { SIGNUP_MUTATION, LOGIN_MUTATION } from './mutations';

const SignupContainer = styled.div`
    ${media.medium`min-height: calc(100vh - 108px);`}
    display: flex;
    padding-top: 15vh;

    .form-container {
        max-width: 600px;
        margin: 0 auto;
        text-align: center;

        .title-container {
            margin-bottom: 30px;
            h1 {
                font-size: 4rem;
                margin: 0;
                color: #000;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
            }
        }

        form {
            .input-row {
                display: flex;

                .input-container {
                    &:first-child {
                        margin-right: 10px;
                    }
                }
            }
            .input-container {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 20px;

                &.submit {
                    align-items: baseline;
                }

                &.optin {
                    p {
                        flex: 1;
                        font-size: 0.9rem;
                        text-align: left;
                        margin: 0;
                    }
                    input {
                        flex: 0;
                        position: relative;
                        top: 8px;
                        margin-right: 10px;
                    }
                }

                label {
                    flex: 1 1 100%;
                    text-align: left;
                    font-weight: bold;
                    color: #000;
                }

                input {
                    flex: 1 1 100%;
                    border: 1px solid #f2f0eb;
                    padding: 10px 0 10px 10px;
                    line-height: 1;
                    background-color: #f2f0eb;
                }

                .label-container {
                    display: flex;

                    label {
                        flex: 1;
                    }
                    .link {
                        flex: 1;
                        text-align: right;
                    }
                }

                .btn-container {
                    flex: 1;
                    text-align: left;

                    button {
                        color: #fff;
                        border: none;
                        background-color: #f74d33;
                        font-weight: 700;
                        line-height: 1;
                        height: 60px;
                        width: 100%;
                        max-width: 112px;
                        border-radius: 5px;
                    }
                }
                .link-container {
                    flex: 1.5;
                    text-align: right;
                    p {
                        margin: 0;
                        font-size: 0.8rem;

                        a {
                            color: #000;
                            color: #702716;
                            &:hover {
                                opacity: 0.7;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const Signup = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [optin, setOptin] = useState(false);

    const [customerCreate, { data }] = useMutation(SIGNUP_MUTATION);
    const [customerAccessTokenCreate, { moreData }] = useMutation(
        LOGIN_MUTATION
    );
    function handleFormSubmit(e) {
        e.preventDefault();
        // first create customer
        customerCreate({
            variables: {
                input: {
                    firstName,
                    lastName,
                    email,
                    password,
                },
            },
        })
            .then((res) => {
                // once they signup successfully, log them in

                customerAccessTokenCreate({
                    variables: {
                        input: {
                            email,
                            password,
                        },
                    },
                }).then((res) => {
                    // console.log('token created', res);
                });
            })

            .catch((error) => {
                console.log(error);
            });
    }
    return (
        <SignupContainer>
            <SEO title="Sign Up" />
            <Wrapper className="form-container">
                <div className="title-container">
                    <h1>Sign up.</h1>
                </div>

                <form onSubmit={(e) => handleFormSubmit(e)}>
                    <div className="input-row">
                        <div className="input-container">
                            <label htmlFor="first_name">First Name</label>
                            <input
                                onChange={(e) => setFirstName(e.target.value)}
                                value={firstName}
                                type="text"
                                name="first_name"
                                required
                            />
                        </div>
                        <div className="input-container">
                            <label htmlFor="last_name">Last Name</label>
                            <input
                                onChange={(e) => setLastName(e.target.value)}
                                value={lastName}
                                type="text"
                                name="last_name"
                                required
                            />
                        </div>
                    </div>

                    <div className="input-container">
                        <label htmlFor="email">Email</label>
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            type="email"
                            name="email"
                            required
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="password">Password</label>
                        <input
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            type="password"
                            name="password"
                            required
                        />
                    </div>
                    <div className="input-container optin">
                        <input
                            onChange={() => setOptin(!optin)}
                            checked={optin}
                            type="checkbox"
                            name="opt-in"
                        />
                        <p>Receive discounts and news in your email.</p>
                    </div>
                    <div className="input-container submit">
                        <div className="btn-container">
                            <button type="submit">Sign Up</button>
                        </div>
                        <div className="link-container">
                            <p>
                                Have an account?{' '}
                                <Link to="/accounts/login">Login here</Link>
                            </p>
                        </div>
                    </div>
                </form>
            </Wrapper>
        </SignupContainer>
    );
};

export default Signup;
